/* eslint-disable */

import { register } from 'register-service-worker';

//  if(window.location.hostname !== 'localhost')
 {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registered(registration) {
      console.log('Service worker has been registered.');
    },
    ready() {
      console.log('App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB');
    },
    cached(registration) {
      console.log('Content has been cached for offline use.');
    },
    updatefound (registration) {
      console.log(registration)
      console.log('New content is downloading.')
    },
   async  updated(registration) {
      console.log('New content is available; please refresh.');
      const worker = registration.waiting;
      await worker.postMessage({ action: 'SKIP_WAITING' });
      setTimeout(() => {
        console.info('Reloading the app...');
        // clear cache
        // localForage.clear();
        // window.location.reload(true);
      }, 1500);
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}
